import { SlideUpModal } from "src/components/SlideUpModal";

type ConfirmDiscardApplicationModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
  confirmHandler: () => void;
};

export default ({
  isOpen,
  closeHandler,
  confirmHandler,
}: ConfirmDiscardApplicationModalProps) => {
  return (
    <SlideUpModal
      title="Are you sure you want to discard your current application and start a fresh one?"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Continue"
      actionButtonClickHandler={confirmHandler}
    />
  );
};
